import { Typography, Container } from "@mui/material";
import { Marksome } from "react-marksome";

const TestProcessSlide = () => {
  const { title, point1, point2, point3, point4, point5, point6 } = text;
  return (
    <Container disableGutters sx={styles.rootContainer}>
      <Typography variant="h3" align="left" sx={styles.text}>
        {title}
      </Typography>
      <br />
      <br />
      <Typography paragraph variant="h5" align="left" sx={styles.text}>
        <Marksome text={point1} />
      </Typography>
      <Typography paragraph variant="h5" align="left" sx={styles.text}>
        <Marksome text={point2} />
      </Typography>
      <Typography paragraph variant="h5" align="left" sx={styles.text}>
        <Marksome text={point3} />
      </Typography>
      <Typography paragraph variant="h5" align="left" sx={styles.text}>
        <Marksome text={point4} />
      </Typography>
      <Typography paragraph variant="h5" align="left" sx={styles.text}>
        <Marksome text={point5} />
      </Typography>
      <Typography paragraph variant="h5" align="left" sx={styles.text}>
        <Marksome text={point6} />
      </Typography>
    </Container>
  );
};

export default TestProcessSlide;

const styles = {
  rootContainer: {
    px: "10vw",
    py: "10vh",
    width: "100%",
    height: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    userSelect: "none",
  },
  text: {
    height: "fit-content",
  },
};

const text = {
  title: "Protseduur",
  point1: "• Testimine kestab **7-8 minutit**.",
  point2: "• Testimise keskel on **väike paus**.",
  point3: "• Teil tuleb lugeda valju häälega **50 üksikut sõna**.",
  point4: "• Sõnad on üldjuhul **algvormis** (tool, sööma).",
  point5: "• Mõned sõnad on **muutevormis** (tooli, sõin).",
  point6: "• Enne sõna valju häälega lugemist, lugege seda **silmadega**.",
};
